import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "confirmationHover",
  class: "confHover",
  hidden: ""
}
const _hoisted_2 = { class: "flex justify-items-center align-middle" }
const _hoisted_3 = { class: "confirmationText" }

import { onMounted, onBeforeUnmount } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmationHover',
  props: {
    text: String,
    yesAction: Function
},
  setup(__props) {

const props = __props;

async function yes() {
    await props.yesAction();
    hideHover();
}

function no() {
    hideHover();
}

const hideHover = ()=>{
    // hide confirmationHover
    const div = document.getElementById('confirmationHover');
    if(div !== null && div !== undefined && !div.hidden){
        div.hidden = true;
		}
};

onMounted(() => {
    // listen to scroll event of popupWrapper
    const popupWrapper = document.getElementById('popupWrapper');
    if(popupWrapper !== null && popupWrapper !== undefined) popupWrapper.addEventListener("scroll", hideHover);
})

onBeforeUnmount(() => {
    // unlisten to scroll event of popupWrapper
    const popupWrapper = document.getElementById('popupWrapper');
    if(popupWrapper !== null && popupWrapper !== undefined) popupWrapper.removeEventListener("scroll", hideHover);
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(props.text), 1),
      _createElementVNode("button", {
        onClick: no,
        class: "closeButton"
      }, _cache[0] || (_cache[0] = [
        _createElementVNode("span", { class: "icon-schliessen" }, null, -1)
      ])),
      _createElementVNode("button", {
        onClick: yes,
        class: "okButton"
      }, _cache[1] || (_cache[1] = [
        _createElementVNode("span", { class: "icon-check" }, null, -1)
      ]))
    ])
  ]))
}
}

})